var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('NewAberrationRuhContainer',{attrs:{"icon":"mdi-progress-wrench","aberrationCategory":"1","categoryName":"Avvik","titleLabel":"Overskrift"},on:{"save":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }